<template>
  <naj-modal
    ref="pdfJudgementsModal"
    :width="1500"
    :footer="true"
    :close-button="true"
    :show-footer-close-button="true"
    @onClose="closePDFJudgementsModal"
  >
    <v-row>
      <v-col cols="2">
        <template v-for="(jud ,index) in judgements">
          <div
            :key="index"
            :class="['row my-5 header-text judgement-entry py-2',{'outlined':jud.objectKey == (selectedJudgement||{}).objectKey}]"
            @click="getJudgementDocument(index)"
          >
            <div class="py-1 text-c-green col-6">
              {{ local.caseFile.cards.judgement.codeDisplayName }}
            </div>
            <div class="py-1 text-info-value col-6">
              {{ jud.judgementCode }}
            </div>
            <div class="py-1 text-c-green col-6">
              {{ local.caseFile.cards.judgement.dateDisplayName }}
            </div>
            <div class="py-1 text-info-value col-6">
              {{ toHijriDate( jud.sakDate) }}
            </div>
          </div>
        </template>
      </v-col>

      <v-col cols="10">
        <div class="preview-holder">
          <pdf-document-viewer
            :document="document"
            :loading="loading"
            :has-pdf-document="!!selectedJudgement.spid"
            :file-name="documentFileName"
            :download-button-text="local.caseFile.cards.judgement.downloadDocument"
            :auto-download-on-mobile="true"
            @downloaded="onDocumentDownloaded"
          />
        </div>
      </v-col>
    </v-row>

    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    />
  </naj-modal>
</template>

<script>
import PdfDocumentViewer from '../components/file-viewer/pdf-document-viewer.vue';

import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCaseActions } = createNamespacedHelpers('CasesModule');
import { toHijriDate } from '@/helpers/utils';

export default {
  name: 'PdfJudgementsModal',
  components: {
    PdfDocumentViewer,
  },
  props: {
    judgements: {
      type: Array,
      required: true,
    },
    modalVisibility: {
      type: Boolean,
      required: true,
    },
    selectedJudgementIndexProp: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      document: null,
      selectedJudgementIndex: this.selectedJudgementIndexProp,
    };
  },
  computed: {
    selectedJudgement() {
      return ((this.judgements || [])[this.selectedJudgementIndex]) || {};
    },
    documentFileName() {
      const judgementCode = this.selectedJudgement.judgementCode || 'judgement';
      return `${judgementCode}.pdf`;
    },
  },
  methods: {
    ...mapCaseActions(['getTrustedSourceAttachment']),
    toHijriDate,
    closePDFJudgementsModal() {
      this.resetData();
      this.$emit('modalClose');
    },
    resetData() {
      this.document = null;
      this.loading = false;
    },
    getJudgementDocument(index) {
      this.selectedJudgementIndex = index;
      if (!this.selectedJudgement.spid) {
        this.document = this.selectedJudgement.judgementText;
        return;
      }
      this.loading = true;
      this.getTrustedSourceAttachment(this.selectedJudgement.spid)
        .then((attachment) => {
          this.document = `data:application/pdf;base64,${attachment}`;
        })
        .finally(
          () => (this.loading = false)
        );
    },
    onDocumentDownloaded(fileName) {
      // Handle document downloaded event if needed
      console.log('Document downloaded:', fileName);
    },
  },
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        this.$refs.pdfJudgementsModal.show();
        this.getJudgementDocument(this.selectedJudgementIndexProp);
      } else {
        this.$refs.pdfJudgementsModal.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-holder {
  display: block !important;
  height: 600px;
  width: 100%;
}

.judgement-entry {
  border: 2px solid #a2a2a2;
  border-radius: 5px;
  cursor: pointer;
  &.outlined {
    border: 4px solid #1fb9b8;
  }

  .text-info-value {
    font-size: 14px;
    font-weight: bold;
  }
}
</style>